import React from 'react';

import Icon from 'ds/Icon';
import { IconButton, Layout, Text } from 'ds';

import HeroConvoSlides, { HERO_CONVO_SLIDES } from './HeroConvoSlides';

const HeroSlackPanel: React.FC = () => {
  return (
    <div className="HomeV10-slackCard">
      <div className="HomeV10-slackHeader">
        <Text size="body-md" semibold color="gray-400">
          #
        </Text>
        <Text size="body-md" semibold color="gray-900" __style={{ flex: 1 }}>
          office-requests
        </Text>
      </div>
      <HeroConvoSlides slides={HERO_CONVO_SLIDES} />
      <div className="HomeV10-composeBar">
        <IconButton name="plus" size="sm" type="gray" onClick={() => undefined} stroke={2} iconColor="gray-600" />
        <Layout flex flexGrow={1} align="center" gap={6} minWidth={0}>
          <span className="HomeV10-composeCursor" aria-hidden />
          <Text size="body-md" color="gray-400">
            Message Codi
          </Text>
        </Layout>
        <Layout
          flex
          flexShrink={0}
          justify="center"
          align="center"
          width={32}
          height={32}
          borderRadius={16}
          color="blue-500"
        >
          <Icon name="upArrow" size="xs" color="white" stroke={2} />
        </Layout>
      </div>
    </div>
  );
};

export default HeroSlackPanel;
